import { Box, Button, Popover, Portal, Slider } from '@chakra-ui/react'
import { useStore } from '@tanstack/react-store'
import { userCardStore } from 'shared/store/userCard'

export const LimitPopup = () => {
  const { incomingTransfers } = useStore(userCardStore)
  const limit = incomingTransfers?.limit

  const handleSlider = ({ value }) => {
    userCardStore.setState((state) => {
      return {
        ...state,
        incomingTransfers: {
          ...state.incomingTransfers,
          limit: value[0],
        },
      }
    })
  }

  return (
    <>
      <Popover.Root>
        <Popover.Trigger colorPalette="gray" asChild>
          <Button width="86px" size="sm">
            {limit} шт.
          </Button>
        </Popover.Trigger>
        <Portal>
          <Popover.Positioner>
            <Popover.Content
              borderWidth={0}
              boxShadow="rgba(15, 15, 15, 0.05) 0px 0px 0px 1px, rgba(15, 15, 15, 0.1) 0px 3px 6px, rgba(15, 15, 15, 0.1) 0px 9px 24px"
              _focus={{
                boxShadow:
                  'rgba(15, 15, 15, 0.05) 0px 0px 0px 1px, rgba(15, 15, 15, 0.1) 0px 3px 6px, rgba(15, 15, 15, 0.1) 0px 9px 24px',
              }}
            >
              <Popover.Arrow />
              <Popover.Body>
                <Slider.Root
                  defaultValue={[limit]}
                  min={20}
                  max={300}
                  step={20}
                  onValueChange={handleSlider}
                >
                  <Slider.Control>
                    <Slider.Track colorPalette="orange">
                      <Box position="relative" right={10} />
                      <Slider.Range />
                    </Slider.Track>
                    <Slider.Thumb index={0} boxSize={6} />
                  </Slider.Control>
                </Slider.Root>
              </Popover.Body>
            </Popover.Content>
          </Popover.Positioner>
        </Portal>
      </Popover.Root>
    </>
  )
}
